var Glyphicon = require("components/utility/icons/Glyphicon");

require("org/roster_upload/roster_upload_buttons.scss");

class RosterUploadButtons extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	confirmChanges(e) {
		$wr.nope(e)
		this.props.confirmChanges();
	}

	next(e) {
		$wr.nope(e)
		this.props.nextStage();
	}

	back(e) {
		$wr.nope(e)
		this.props.nextStage(true);
	}

	render() {
		if (this.props.editMode) {
			if (this.props.forceEdits) {
				var forceText = (
					<p>
						<em>You must make edits to your student data to proceed.</em>
					</p>
				);
			} else {
				var cancelButton = (
					<button className="btn btn-link" onClick={ this.props.toggleEditMode } >
						Restore
					</button>
				);
			}

			return (
				<div className="rosterUploadButtons">
					{ forceText }
					<div className="text-center clearfix">
						<button className="btn buttonDefault pull-left" onClick={ this.back }>
							<Glyphicon icon="arrow-left"/> Back
						</button>
						<button className="btn buttonSuccess" onClick={ this.confirmChanges } >
							Confirm Changes
						</button>
						{ cancelButton }
					</div>
				</div>
			);

		} else {
			if (!this.props.finalStage) {
				var editButton = (
					<button className="btn btn-link" onClick={ this.props.toggleEditMode }>
						Edit { this.props.noun }
					</button>
				);
			}

			if (this.props.nextStage) {
				var nextButton = (
					<button className="btn buttonSuccess pull-right" onClick={ this.next }>
						<Glyphicon icon="arrow-right"/> { this.props.finalStage ? "Finish" : "Next" }
					</button>
				);
			}

			return (
				<div className="rosterUploadButtons">
					<div className="clearfix text-center">
						<button className="btn buttonDefault pull-left" onClick={ this.back }>
							<Glyphicon icon="arrow-left"/> Back
						</button>
						{ editButton }
						{ nextButton }
					</div>
				</div>
			);
		}
	}
};

RosterUploadButtons.propTypes = StrictPropTypes({
	// What are we editing?
	noun: PropTypes.string,

	// If true, show the edit controls
	editMode: PropTypes.bool,

	// Don't allow restoring from editMode
	forceEdits: PropTypes.bool,

	// For the final state, use different text and hide edits
	finalStage: PropTypes.bool,

	// Needed unless finalStage is true to handle edits
	toggleEditMode: PropTypes.func,
	confirmChanges: PropTypes.func,

	nextStage: PropTypes.func.isRequired,
});

module.exports = RosterUploadButtons;



// WEBPACK FOOTER //
// ./modules/components/org/roster_upload/RosterUploadButtons.js